import React from "react";
import { Page } from "components/Page";

export const FullPage = ({ children }) => {
  return <Page data-testid="pm-fullpage">{children}</Page>;
};
